/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect, useRef } from 'react'; // 1. เพิ่ม useRef เข้ามา

// ประกาศตัวแปรรับค่าจาก env
const API_URL = import.meta.env.VITE_API_URL;

function AllDepartment() {
  const { data, setData } = useDataContext();
  
  // 2. สร้างตัวแปรกันยิงซ้ำ (Protection Flag)
  const hasFetched = useRef(false);

  useEffect(() => {
    // -----------------------------------------------------------
    // ✅ จุดแก้ที่ 1: เช็คว่ามีข้อมูลใน Context หรือยัง?
    // -----------------------------------------------------------
    if (data?.getAllEmployees && data.getAllEmployees.length > 0) {
      // console.log("Employees data already exists. Skipping fetch.");
      return;
    }

    // -----------------------------------------------------------
    // ✅ จุดแก้ที่ 2: เช็คว่า Component นี้เคยสั่งยิงไปแล้วหรือยัง?
    // -----------------------------------------------------------
    if (hasFetched.current) return;

    const fetchData = async () => {
      // Mark ว่ากำลังยิงแล้วนะ ห้ามยิงซ้ำ
      hasFetched.current = true;

      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      try {
        // ✅ ใช้ API_URL แทน Hardcode URL
        const response = await fetch(`${API_URL}/getAllEmployees`, requestOptions);
        const result = await response.json();
        
        // ตรวจสอบข้อมูล technician
        if (result.data && result.data.length > 0) {
          const sampleEmployee = result.data[0];
          console.log('Sample employee data structure:', {
            employeeId: sampleEmployee.employeeId,
            nameTh: sampleEmployee.nameTh,
            isTechnician: sampleEmployee.isTechnician,
            technicianSpecialization: sampleEmployee.technicianSpecialization,
            technicianAssignedDate: sampleEmployee.technicianAssignedDate,
            hasAllTechnicianFields: !!(
              sampleEmployee.hasOwnProperty('isTechnician') &&
              sampleEmployee.hasOwnProperty('technicianSpecialization') &&
              sampleEmployee.hasOwnProperty('technicianAssignedBy')
            )
          });
          
          // หาพนักงานที่เป็นช่าง
          const technicians = result.data.filter(emp => emp.isTechnician === "1" || emp.isTechnician === 1);
          if (technicians.length > 0) {
            console.log(`Found ${technicians.length} technicians:`, technicians.map(t => ({
              employeeCode: t.employeeCode,
              nameTh: t.nameTh,
              isTechnician: t.isTechnician,
              specialization: t.technicianSpecialization
            })));
          } else {
            console.log('No technicians found in current data');
          }
        }
        
        // อัปเดตข้อมูลเข้า Context
        setData(prevData => ({
            ...prevData, 
            getAllEmployees: result.data || [] 
        }));
      } catch (error) {
        console.error("Error fetching employees:", error);
        hasFetched.current = false; // ถ้า Error ให้ reset เผื่อจะ retry ได้
      }
    };

    fetchData();
    
    // -----------------------------------------------------------
    // ✅ จุดแก้ที่ 3: Dependency Array ต้องว่าง [] 
    // -----------------------------------------------------------
  }, []); 

  return null;
}

export default AllDepartment;
